import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import axiosInstance from "../../../axiosInstance";
import { useNavigate } from "react-router-dom";
import ExternalScripts from "../../../common/ExternalScripts";

const AddListingSection = () => {
  const allSteps = ["Car Details","Price","Features","Media","Final"]
  const [currentStep,setCurrentStep] = useState("Car Details") 
  const [carDetails,setCarDetails] = useState({
    title:"",type:"",mileage:"",model:"",year:"",company:"",transmission:"",engineSize:"",color:"",fuelType:"",door:"",description:"", category:""
  })
  const [loading,setLoading] = useState(false)
  const [error,setError] = useState("")
  const [carId,setCarId] = useState("")
  const [price,setPrice] = useState({amount:"0",taxPercentage:13,taxAmount:0,totalPrice:0})
  const [loading2,setLoading2] = useState(false)
  const [error2,setError2] = useState("")
  const [features,setFeatures] = useState([])
  const [loading3,setLoading3] = useState(false)
  const [error3,setError3] = useState("")
  const [files,setfiles] = useState([])
  const [loading4,setLoading4] = useState(false)
  const [error4,setError4] = useState("")
  const [loading5,setLoading5] = useState(false)
  const [error5,setError5] = useState("")
  const [flag,setFlag] = useState("")
  const [drop,setDrop] = useState({
  flag: false,
  fuel: false,
  door: false,
  category: false
})
  const image = useRef()
  const navigate = useNavigate()
  const setCars = (event) => {
    const {name,value} = event.target
    setCarDetails({...carDetails,[name]:value})
  }
  const handleSelect = (name,value) => {
    setCarDetails({...carDetails,[name]:value})
  }
  const handleCarSubmit = async(e) => {
    try {
      e.preventDefault()
      setError("")
      setError2("")
      setError3("")
      setError4("")
      setError5("")
      setLoading(true)
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token) return navigate("/")
      const response = await axiosInstance.post("/api/inventory/create-basic",carDetails,{headers:{
        "Authorization":auth.token
      }})
      if(response.status === 201) {
        alert(response?.data?.message)
        setCarId(response?.data?.data?._id)
        setCurrentStep("Price")
        setCarDetails({title:"",type:"",mileage:"",model:"",year:"",company:"",transmission:"",engineSize:"",color:"",fuelType:"",door:"",description:""})
      }
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError(msg);
        }
        else if (error.request) {
          setError("No response from server. Please check your internet connection.");
        }
        else {
          setError(error.message || "Unexpected error occurred.");
        }
      } else {
        setError("An unexpected error occurred.");
      }
    } finally {
      setLoading(false)
    }
  }
  const setPrices = (event) => {
    const {name,value} = event.target
    const taxAmount = (value * price.taxPercentage)/100
    setPrice({...price,[name]:value,taxAmount,totalPrice:parseInt(value || 0)+parseInt(taxAmount || 0)})
  }
  const setTaxes = (value) => {
   const taxAmount = (price.amount * value)/100
   setPrice({...price,"taxAmount":taxAmount,"taxPercentage":value,totalPrice:parseInt(taxAmount || 0)+parseInt(price.amount || 0)})
  }
  const handlePriceSubmit = async(e) => {
    try {
      e.preventDefault()
      setError2("")
      setError3("")
      setError("")
      setError4("")
      setError5("")
      setLoading2(true)
      if(!carId) return setError2("Please add car first")
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token) return navigate("/")
      const response = await axiosInstance.put(`/api/inventory/${carId}/update-price`,price,{headers:{
        "Authorization":auth.token
      }})      
      if(response.status === 200) {
        alert(response?.data?.message)
        setCarId(response?.data?.data?._id)
        setCurrentStep("Features")
        setPrice({amount:"",taxAmount:0,taxPercentage:13,totalPrice:0})
      }
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError2(msg);
        }
        else if (error.request) {
          setError2("No response from server. Please check your internet connection.");
        }
        else {
          setError2(error.message || "Unexpected error occurred.");
        }
      } else {
        setError2("An unexpected error occurred.");
      }
    } finally {
      setLoading2(false)
    }
  }
  const allFeatures = ["Heated Seats","Heated Steering Wheel","Navigation System","Tyre Pressure Monitoring System"
    ,"Apple CarPlay/Android Auto","Bluetooth","HomeLink","Airbag - Driver","Airbag - Passenger","Anti-lock Braking System",
    "Backup Camera","Blind Spot Monitor","Center Console","Heated and Ventilated Front Seats","Panoramic Moonroof",
    "Qi Wireless Charging","Touchscreen Display","Alloy Wheels","Brake Calipers - Silver Painted","Rear Bumper High Gloss","Rear Diffuser Body Colour","Windows - Electric Front"
  ]
const chunkArray = (arr, chunkSize) => {
  const chunks = [];
  const perColumn = Math.ceil(arr.length / chunkSize);

  for (let i = 0; i < chunkSize; i++) {
    chunks.push(arr.slice(i * perColumn, (i + 1) * perColumn));
  }
  return chunks;
};
const columns = chunkArray(allFeatures, 4);
const handleSelectFeatures = (value) => {
  if(features.includes(value)){
    const rest = features.filter(f=>f!==value)
    setFeatures([...rest])
  } else {
    setFeatures([...features,value])
  }
}
const handleFeaturesSubmit = async(e) => {
    try {
      e.preventDefault()
      setError3("")
      setError("")
      setError2("")
      setError4("")
      setError5("")
      setLoading3(true)
      if(!carId) return setError3("Please add car first")
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token) return navigate("/")
      const response = await axiosInstance.put(`/api/inventory/${carId}/update-features`,{features},{headers:{
        "Authorization":auth.token
      }})      
      if(response.status === 200) {
        alert(response?.data?.message)
        setCarId(response?.data?.data?._id)
        setCurrentStep("Media")
        setFeatures([])
      }
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError3(msg);
        }
        else if (error.request) {
          setError3("No response from server. Please check your internet connection.");
        }
        else {
          setError3(error.message || "Unexpected error occurred.");
        }
      } else {
        setError3("An unexpected error occurred.");
      }
    } finally {
      setLoading3(false)
    }
}
const handleUploadImages = (e) => {
  const selectedFiles = Array.from(e.target.files);
  setError4("");
  const allowedTypes = ["image/jpeg", "image/jpg", "image/png"];
  const maxSize = 2 * 1024 * 1024; // 2 MB
  const maxImages = 15;

  let validFiles = [];

  // Check current + new files do not exceed 5
  if (files.length + selectedFiles.length > maxImages) {
    setError4(`You can upload a maximum of ${maxImages} images.`);
    return;
  }

  for (let file of selectedFiles) {
    // Type validation
    if (!allowedTypes.includes(file.type)) {
      setError4(`Invalid file type: ${file.name}. Only JPG, JPEG, PNG allowed.`);
      return;
    }

    // Size validation
    if (file.size > maxSize) {
      setError4(`File too large: ${file.name}. Max size is 2MB.`);
      return;
    }

    validFiles.push(file);
  }

  // Add valid files to state
  setfiles((prev) => [...prev, ...validFiles]);
};
const handleRemoveImage = (index) => {
  files.splice(index,1)
  setfiles([...files])
}
const handleImagesSubmit = async(e) => {
    try {
      e.preventDefault()
      setError("")
      setError3("")
      setError2("")
      setError4("")
      setError5("")
      setLoading4(true)
      if(!carId) return setError3("Please add car first")
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token) return navigate("/")
      const form = new FormData()
      files.forEach((file) => {
        form.append("images", file);
      });
      const response = await axiosInstance.post(`/api/inventory/${carId}/upload-media`,form,{headers:{
        "Content-Type": "multipart/form-data",
        "Authorization":auth.token
      }})            
      if(response.status === 200) {
        alert(response?.data?.message)
        setCarId(response?.data?.data?._id)
        setCurrentStep("Final")
        setfiles([])
      }
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError4(msg);
        }
        else if (error.request) {
          setError4("No response from server. Please check your internet connection.");
        }
        else {
          setError4(error.message || "Unexpected error occurred.");
        }
      } else {
        setError4("An unexpected error occurred.");
      }
    } finally {
      setLoading4(false)
    }
}
const handleFinalSubmit = async(e) => {
    try {
      e.preventDefault()
      setError3("")
      setError("")
      setError2("")
      setError4("")
      setError5("")
      setLoading5(true)
      if(!carId) return setError3("Please add car first")
      const auth = JSON.parse(localStorage.getItem("auth"))
      if(!auth || !auth?.token) return navigate("/")
      const response = await axiosInstance.put(`/api/inventory/${carId}/submit`,{flag},{headers:{
        "Authorization":auth.token
      }})      
      if(response.status === 200) {
        alert(response?.data?.message)
        setCarId("")
        setFlag("")
        setCurrentStep("Car Details")
        navigate("/Dashboard")
      }
      
    } catch (error) {
      if (axios.isAxiosError(error)) {
        if (error.response) {
          const msg = error.response.data?.message || error.response.data?.error || "Something went wrong on the server.";
          setError5(msg);
        }
        else if (error.request) {
          setError5("No response from server. Please check your internet connection.");
        }
        else {
          setError5(error.message || "Unexpected error occurred.");
        }
      } else {
        setError5("An unexpected error occurred.");
      }
    } finally {
      setLoading5(false)
    }
}
  return (
    <>
    <div className="content-column">
      <div className="inner-column">
        <div className="list-title">
          <h3 className="title">Add Vehicle</h3>
          <div className="text">Field marked * are required.</div>
        </div>
        <div className="form-box">

          <ul className="nav nav-tabs" id="myTab" role="tablist">
            {allSteps.map((step,index)=>{
              if(step==="Car Details"){
                return(
                  <li key={index} className="nav-item" role="presentation">
                  <button onClick={()=>setCurrentStep(step)} className={step===currentStep ? "nav-link active":"nav-link"} id="home-tab" data-bs-toggle="tab" data-bs-target="#home" type="button" role="tab" aria-controls="home" aria-selected="true">
                    Car Details
                  </button>
                  </li>
                )
              }
              else {
                return (<li key={index} className="nav-item" role="presentation">
                <button onClick={()=>{
                  if(carId) setCurrentStep(step)
                }} className={step===currentStep ? "nav-link active":"nav-link"} id={`${step}-tab`} data-bs-toggle="tab" data-bs-target={`#${step}`} type="button" role="tab" aria-controls={`${step}`} aria-selected="false">
                {step}
                </button>
                </li>)
              }
            })}
          </ul>
          <div className="tab-content" id="myTabContent">
          <div className={currentStep === "Car Details" ? `tab-pane fade show active` :`tab-pane fade`} id="home" role="tabpanel" aria-labelledby="home-tab">
              <form className="row">
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Title:</label>
                    <input type="text" name="title" onChange={setCars} value={carDetails.title} />
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Vehicle Type:</label>
                    <input type="text" name="type" onChange={setCars} value={carDetails.type}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Mileage:</label>
                    <input type="text" name="mileage" onChange={setCars} value={carDetails.mileage} />
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Model:</label>
                    <input type="text" name="model" onChange={setCars} value={carDetails.model}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Year:</label>
                    <input type="text" name="year" onChange={setCars} value={carDetails.year}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Company:</label>
                    <input type="text" name="company" onChange={setCars} value={carDetails.company}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Transmission:</label>
                    <input type="text" name="transmission" onChange={setCars} value={carDetails.transmission}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Engine Size:</label>
                    <input type="text" name="engineSize" onChange={setCars} value={carDetails.engineSize}/>
                  </div>
                </div>
                <div className="form-column col-lg-4">
                  <div className="form_boxes">
                    <label>Color:</label>
                    <input type="text" name="color" onChange={setCars} value={carDetails.color}/>
                  </div>
                </div>

{/* FUEL TYPE - Working with original theme JS */}
<div  className="form-column col-lg-4">
  <div onClick={()=>setDrop(prev => ({ ...prev, fuel: !prev.fuel, door: false, category: false }))} className="form_boxes">
    <label>Fuel Type</label>
    <div className="drop-menu">
      <div className="select">
        <span>{carDetails.fuelType || "Select Fuel Type"}</span>
        <i className="fa fa-angle-down"></i>
      </div>
      <input type="hidden" name="fuelType" />
      <ul className="dropdownn" style={{display:drop.fuel?"block":"none"}}> 
        {["Petrol", "Diesel", "CNG", "Electric"].map((fuel) => (
          <li
            key={fuel}
            onClick={() => handleSelect("fuelType", fuel)}
          >
            {fuel}
          </li>
        ))}
      </ul>
    </div>
  </div>
</div>

{/* DOORS - Working with original theme JS */}
<div className="form-column col-lg-4">
  <div onClick={()=>setDrop(prev => ({ ...prev, door: !prev.door, fuel: false, category: false }))} className="form_boxes">
    <label>Doors</label>
    <div className="drop-menu">
      <div className="select">
        <span>{carDetails.door || "Select Doors"}</span>
        <i className="fa fa-angle-down"></i>
      </div>
      <input type="hidden" name="door" />
      <ul className="dropdownn" style={{display:drop.door?"block":"none"}}>
        {["2", "3", "4", "5"].map((door) => (
          <li
            key={door}
            onClick={() => handleSelect("door", door)}
          >
            {door} Doors
          </li>
        ))}
      </ul>
    </div>
  </div>
</div>

<div className="form-column col-lg-4">
  <div onClick={()=>setDrop(prev => ({ ...prev, category: !prev.category, fuel: false, door: false }))} className="form_boxes">
    <label>Category</label>
    <div className="drop-menu">
      <div className="select">
        <span>{carDetails.category || "Select Category"}</span>
        <i className="fa fa-angle-down"></i>
      </div>
      <input type="hidden" name="category" />
      <ul className="dropdownn" style={{display:drop.category?"block":"none"}}>
        {["SUV", "Sedan", "Hatchback", "Convertible"].map((category) => (
          <li
            key={category}
            onClick={() => handleSelect("category", category)}
          >
            {category}
          </li>
        ))}
      </ul>
    </div>
  </div>
</div>
                <div className="form-column col-lg-12">
                  <div className="form_boxes v2">
                    <label>Listing Description</label>
                    <div className="drop-menu">
                      <textarea name="description" onChange={setCars} value={carDetails.description} placeholder="Enter Description" />
                    </div>
                  </div>
                </div>
                {error && <p style={{fontSize:"18px",color:"red"}}>{error}</p>}
                <div className="col-lg-12">
                  <div className="form-submit">
                    <button disabled={loading} onClick={handleCarSubmit} type="submit" className="theme-btn">
                      {loading ? "Processing..." : "Next Price"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          
            <div className={currentStep === "Price" ? `tab-pane fade show active` : `tab-pane fade`} id={allSteps[1]} aria-labelledby={`${allSteps[1]}-tab`} role="tabpanel"> 
              <form className="row">
                <div className="col-lg-4">
                  <div className="form_boxes v2">
                    <label>Amount ($)</label>
                    <input type="number" name="amount" value={price.amount} onChange={setPrices}/>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form_boxes v2">
                    <label>Tax (%)</label>
                    <input type="number" value={price.taxPercentage} name="taxPercentage" onChange={(e)=>setTaxes(e.target.value)}/>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form_boxes v2">
                    <label>Tax Amount($)</label>
                    <input type="number" value={price.taxAmount} disabled={true} readOnly={true} name="taxAmount"/>
                  </div>
                </div>
                <div className="col-lg-4">
                  <div className="form_boxes v2">
                    <label>Total Price ($)</label>
                    <input type="number" value={price.totalPrice} name="totalPrice" disabled={true} readOnly ={true}/>
                  </div>
                </div>
                {error2 && <p style={{fontSize:"18px",color:"red"}}>{error2}</p>}
                <div className="col-lg-12">
                  <div className="form-submit">
                    <button onClick={handlePriceSubmit} disabled={loading2} type="submit" className="theme-btn">
                      {loading2 ? "Processing..." : "Next Features"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
            <div className={currentStep === "Features" ? `tab-pane fade cheak-box-sec style1 show active`:`tab-pane fade cheak-box-sec style1`} id={allSteps[2]} aria-labelledby={`${allSteps[2]}-tab`} role="tabpanel">
              <div className="right-box-two">
                { columns.map((col,index)=><div key={index} className="cheak-box">
                  {col?.map((f,i)=><label key={i} className="contain">
                    <input type="checkbox" onClick={()=>handleSelectFeatures(f)} checked={features.includes(f)?true:false} readOnly/>{f}
                    <span className="checkmark" />
                  </label>)}
                </div>)}
              </div>
              {error3 && <p style={{fontSize:"18px",color:"red"}}>{error3}</p>}
              <div className="btn-box">
                <button onClick={handleFeaturesSubmit} disabled={loading3} className="form-btn">
                  {loading3? "Processing..." : "Next Media"}
                </button>
              </div>
            </div>
            <div className={currentStep === "Media" ? `tab-pane fade gallery-sec style1 show active` : `tab-pane fade gallery-sec style1`} id={allSteps[3]} role="tabpanel" aria-labelledby={`${allSteps[3]}-tab`}>
              <div className="right-box-three">
                <h6 className="fuelType">Gallery</h6>
                <div className="gallery-box">
                  <div className="inner-box" style={{display:"flex",gap:"10px",flexWrap:"wrap"}} >
                    {
                      files?.map((file,index) => <div style={{height:"200px",width:"300px"}} key={index} className="image-box">
                      <img style={{height:"100%",width:"100%",objectFit:"cover"}} src={URL.createObjectURL(file)}/>
                      <div className="content-box">
                        <ul className="social-icon">
                          <li>
                            <a style={{cursor:"pointer"}} onClick={()=>handleRemoveImage(index)} >
                              <img src="images/resource/delet.svg" />
                            </a>
                          </li>
                        </ul>
                      </div>
                    </div>)
                    }
                    { files.length<5 && <div className="uplode-box">
                      <div onClick={()=>image.current.click()} className="content-box">
                        <input ref={image} onChange={handleUploadImages}  multiple accept="image/jpeg,image/jpg,image/png" type="file" hidden />
                        <a href="#">
                          <img src="images/resource/uplode.svg" />
                          <span>Upload</span>
                        </a>
                      </div>
                    </div> 
                    }
                  </div>
                  <div className="text">
                    Max file size is 2MB, Minimum dimension: 330x300 And
                    Suitable files are .jpg, jpeg &amp; .png
                  </div>
                </div>
              </div>
              
              <div className="form-sec">
                <form className="row">
                  {error4 && <p style={{ color: "red",fontSize:"18px" }}>{error4}</p>}
                  <div className="form-submit">
                    <button onClick={handleImagesSubmit} disabled={loading4} type="submit" className="theme-btn">
                      {loading4 ? "Processing..." : "Next "}
                    </button>
                  </div>
                </form>
              </div>
            </div>
            <div className={currentStep === "Final" ? `tab-pane fade show active` : `tab-pane fade`} id={allSteps[4]} role="tabpanel" aria-labelledby={`${allSteps[4]}-tab`} >
              <form className="row">
                <div className="col-lg-6">
                  <div className="inner-box">
                    <div className="form_boxes">
                      <label>Status (For Pubic it must be active)</label>
                      <div className="drop-menu">
                        <div className="select">
                          <span>Active</span>
                        </div>
                        {/* <input type="hidden" name="gender" />
                        <ul className="dropdown" style={{ display: "none" }}>
                          <li onClick={()=>handleStatusSelect("Yes")}>Active</li>
                          <li onClick={()=>handleStatusSelect("No")}>Not-Active</li>
                        </ul> */}
                      </div>
                    </div>
                  </div>
                </div>
                <div className="col-lg-6">
                  <div className="inner-box">
                    <div onClick={()=>setDrop(prev => ({ ...prev, flag: !prev.flag, fuel: false, door: false, category: false }))} className="form_boxes">
                      <label>Flag (For Showing it to Pubic)</label>
                      <div className="drop-menu">
                        <div className="select">
                          <span>{flag || "Choose Flag"}</span>
                        </div>
                        <input type="hidden" name="gender" />
                        <ul className="dropdownn" style={{ display: drop.flag ? "block" : "none" }}>
                          <li onClick={()=>setFlag("Sold")}>Sold</li>
                          <li onClick={()=>setFlag("New")}>New</li>
                          <li onClick={()=>setFlag("Used")}>Used</li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
                {error5 && <p style={{fontSize:"18px",color:"red"}}>{error5}</p>}
                <div className="col-lg-12">
                  <div className="form-submit">
                    <button onClick={handleFinalSubmit} disabled={loading5} type="submit" className="theme-btn">
                      {loading5 ? "Submitting..." : "Submit"}
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
};

export default AddListingSection;
